module.exports = __webpack_public_path__ + "static/img/enter.73729e4b.png";